// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3DO8p","title":"Header_title__drZzU","side":"Header_side__3NXQB"};